import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { ModalConfirmacaoService } from 'src/app/shared/services/modal-confirmacao.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { IFilial } from '../../data/filiais';
import { FiliaisService } from '../../services/filiais.service';



@Component({
  selector: 'app-filiais-list',
  templateUrl: './filiais-list.component.html',
  styleUrls: ['./filiais-list.component.scss']
})
export class FiliaisListComponent {
  ERoleAdminString = ERoleAdminString;
  @Output() mudouPagina = new EventEmitter<number>();
  @Output() mudouTamanhoPagina = new EventEmitter<number>();
  @Output() recarregarListagem = new EventEmitter();
  @Output() editarFilial = new EventEmitter();
  @Input() filiais: IFilial[] = [];
  @Input() dadosPaginacao: {
    paginaSelecionada: number;
    tamanhoPagina: number;
    totalPaginas: number;
    itensTotal: number;
  } = {
      paginaSelecionada: 0,
      tamanhoPagina: 10,
      totalPaginas: 0,
      itensTotal: 0
    };

  constructor(
    private readonly filiaisService: FiliaisService,
    private readonly modalConfirmacao: ModalConfirmacaoService,
    private readonly toastService: ToastService
  ) { }


  // carregarFiliais(): void {
  //   this.filiaisService.listarTodasFiliais({
  //     orderBy: Number(this.dadosPaginacao),
  //     pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
  //     pageSize: Number(this.dadosPaginacao.tamanhoPagina),
  //   })
  //     .subscribe((res) => {
  //       this.filiais = res.data;
  //       this.dadosPaginacao.totalPaginas = Math.ceil(res.count! / this.dadosPaginacao.tamanhoPagina);
  //       this.dadosPaginacao.itensTotal = res.count!;

  //     });
  // }

  public toogleEmpresaStatus(filialId: string, status: boolean): void {
    const textoStatus = status ? 'desativar' : 'ativar';

    this.modalConfirmacao
      .abrirModalConfirmacao({
        mensagem: `Tem certeza que deseja ${textoStatus} a filial?`
      })
      .subscribe((resposta) => {
        if (!resposta) return;

        if (status) {
          this.filiaisService.desativarFilial(filialId).subscribe((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            if (resposta.isSucceed) {
              this.recarregarListagem.emit();
            }
          });
        } else {
          this.filiaisService.ativarFilial(filialId).subscribe((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            if (resposta.isSucceed) {
              this.recarregarListagem.emit();
            }
          });
        }
      });
  }

  onEditarFilial(id: string): void {
    this.editarFilial.emit(id);
  }

}
